const initialState = {
  userDetails: null,
  currentLang: { lang: 'ar', id: 1 },
};
export default initialState;
